const config = {
  rowSelection: false,
  listTitle: '空间类型管理',
  searchFormConfig: false,
  searchMode: "group",
  columns: [
    {
      title: "ID",
      dataIndex: "id",
      width: 120
    },
    {
      title: "空间类型编码",
      dataIndex: "code",
      width: 150
    },
    {
      title: "空间类型名称",
      dataIndex: "name",
      width: 150
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: 150
    },
    {
      title: "最后修改人",
      dataIndex: "modifiedByName",
      width: 120
    },
    {
      title: "最后修改时间",
      dataIndex: "lastUpdatedTime",
      itemType: "dateTime",
      width: 150
    },
    {
      title: "操作",
      dataIndex: "actionTool",
      width: 150,
      render: "actionTool",
      fixed: "right"
    }
  ],
  search: [
    {
      name: "name",
      label: "空间类型名称",
      labelProps: {
        width: 90
      }
    },
    {
      name: "code",
      label: "空间类型编码",
      labelProps: {
        width: 90
      }
    },
  ],
  footer: [
    {
      label: "新增",
      type: "primary",
      events: ["onClick:onAdd"]
    }
  ]
}


export default config